import { render, staticRenderFns } from "./SizingDetail.vue?vue&type=template&id=f3c43686&scoped=true"
import script from "./SizingDetail.vue?vue&type=script&lang=js"
export * from "./SizingDetail.vue?vue&type=script&lang=js"
import style0 from "./SizingDetail.vue?vue&type=style&index=0&id=f3c43686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c43686",
  null
  
)

export default component.exports